import React, { useContext, useState } from "react";
import { CartContext } from "../Component/CartContext";
import "../css/checkout.css";
import productData from "../Datas/productData";
import { Link, useLocation } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";

const CheckOut = () => {
  const { cartItems } = useContext(CartContext);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address1, setAddress1] = useState("");
  const [ship, setShip] = useState("");
  const [errors, setErrors] = useState({});
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [contact, setContact] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [company, setCompany] = useState("");
  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const location = useLocation();
  const { sub } = location.state || {};

  const handlePlaceOrder = () => {
    const newErrors = {};
    const email = contact.trim();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailPattern.test(email)) newErrors.contact = "Enter a valid email address";
    if (!countryCode) newErrors.countryCode = "Select a country";
    if (!postalCode) newErrors.postalCode = "Enter a ZIP / postal code";
    if (!firstName) newErrors.firstName = "Enter a first name";
    if (!lastName) newErrors.lastName = "Enter a last name";
    if (!address) newErrors.address = "Enter an address";
    if (!city) newErrors.city = "Enter a city";
    if (!ship) newErrors.ship = "Enter a shipping method";
    if (cartItems.length === 0) newErrors.cart = "Your cart is empty";

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return;
    }

    const firstProduct = getProductById(cartItems[0].id);
    if (!firstProduct) {
      setErrors({ cart: "The first product in your cart is unavailable" });
      return;
    }

    const randomValues = new Uint32Array(2);
    window.crypto.getRandomValues(randomValues);
    const randomPart = Array.from(randomValues)
      .map((value) => String(value).padStart(10, "0"))
      .join("")
      .slice(0, 14);
    const orderNo = `${Date.now()}${randomPart}`;
    const paymentResultUrl = new URL("/payment", window.location.origin);
    const paymentUrl = new URL("/create_payment.php", window.location.origin);

    paymentUrl.search = new URLSearchParams({
      orderNo,
      amount: calculateTotal().toFixed(2),
      currency: "USD",
      email,
      success_url: `${paymentResultUrl.toString()}?state=success`,
      cancel_url: `${paymentResultUrl.toString()}?state=cancel`,
      title: firstProduct.name,
    }).toString();

    setIsRedirecting(true);
    window.location.assign(paymentUrl.toString());
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      const product = getProductById(item.id);
      if (!product) return total;

      const price = parseFloat(product.price.replace(/,/g, ""));
      return total + price * item.quantity;
    }, 0);
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      id="ban-do-we-exist-to-help-you-be-your-best"
      className="template-index theme-animate-hover"
    >
      <div className="main-containerCheck">
        <div className="check-custom-checkout-page">
          <div className="left">
            <div className="check-order-info">
              <form
                id="checkout-form"
                onSubmit={(event) => {
                  event.preventDefault();
                  handlePlaceOrder();
                }}
                noValidate
              >
                <div className="form-group">
                  <label htmlFor="contact">Email</label>
                  <input
                    type="email"
                    id="contact"
                    name="contact"
                    value={contact}
                    placeholder="Email address"
                    onChange={(e) => setContact(e.target.value)}
                    required
                  />
                  {errors.contact && <p className="error">{errors.contact}</p>}
                </div>

                <div className="form-group">
                  <label>Delivery</label>
                  <ReactFlagsSelect
                    selected={countryCode}
                    onSelect={(code) => setCountryCode(code)}
                    className="check-select"
                  />
                  {errors.countryCode && (
                    <p className="error">{errors.countryCode}</p>
                  )}
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={firstName}
                      placeholder="First name *"
                      onChange={(e) => setFirstName(e.target.value)}
                      required
                    />
                    {errors.firstName && (
                      <p className="error">{errors.firstName}</p>
                    )}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={lastName}
                      placeholder="Last name *"
                      onChange={(e) => setLastName(e.target.value)}
                      required
                    />
                    {errors.lastName && (
                      <p className="error">{errors.lastName}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="company-name"
                    name="company-name"
                    value={company}
                    onChange={(e) => setCompany(e.target.value)}
                    placeholder="Company name (optional)"
                  />
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address"
                    name="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    required
                    placeholder="Address"
                  />
                  {errors.address && <p className="error">{errors.address}</p>}
                </div>

                <div className="form-group">
                  <input
                    type="text"
                    id="address1"
                    name="address1"
                    value={address1}
                    onChange={(e) => setAddress1(e.target.value)}
                    required
                    placeholder="Apartment, suite, etc. (optional)"
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={city}
                      placeholder="city"
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                    {errors.city && <p className="error">{errors.city}</p>}
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      id="postalCode"
                      name="postalCode"
                      value={postalCode}
                      placeholder="Postal code"
                      onChange={(e) => setPostalCode(e.target.value)}
                      required
                    />
                    {errors.postalCode && (
                      <p className="error">{errors.postalCode}</p>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label>Shipping method</label>
                  <input
                    type="text"
                    id="ship"
                    name="ship"
                    value={ship}
                    onChange={(e) => setShip(e.target.value)}
                    required
                    placeholder="Enter your shipping address to view available shipping methods."
                  />
                  {errors.ship && <p className="error">{errors.ship}</p>}
                </div>
              </form>
              {errors.cart && <p className="error checkout-error">{errors.cart}</p>}
              <button
                type="submit"
                form="checkout-form"
                className="check-checkout-button"
                disabled={isRedirecting}
              >
                {isRedirecting ? "Redirecting…" : "Pay Now"}
              </button>

              <p>
                <Link
                  to="/returns"
                  style={{ textDecoration: "underline" }}
                  onClick={toTop}
                >
                  Shipping & Returns Info
                </Link>
              </p>
            </div>
          </div>

          {!sub && (
            <div className="right">
              <div className="check-order-summary">
                <div className="check-order-details">
                  {cartItems.map((item, index) => {
                    const product = getProductById(item.id);
                    if (!product || !product.images) return null;
                    return (
                      <div key={index} className="check-cart-item">
                        <img src={product.images[0]} alt="Product" />
                        <div className="pro--qty">
                          <div className="qty-inner">{item.quantity}</div>
                        </div>
                        <div className="check-item-details">
                          <h3>
                            {product.name}
                            {item.size && (
                              <>
                                <br />
                                Size: {item.size}
                              </>
                            )}
                            {item.color && (
                              <>
                                <br />
                                Color: {item.color}
                              </>
                            )}
                          </h3>
                        </div>
                        <p className="cal-single">${product.price} </p>
                      </div>
                    );
                  })}

                  <div className="check-summary-details">
                    <div className="gridTotal">
                      <table className="summary-details22">
                        <tbody className="sumTbody22">
                          <tr className="sumTr22">
                            <th
                              className="subtotalTh22"
                              style={{ fontSize: "24px" }}
                            >
                              Total
                            </th>
                            <th className="subtotalTxt22">
                              ${calculateTotal().toFixed(2)}
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CheckOut;
